import React, { Component } from 'react';
import axios from 'axios';
import {  Box, Button, Checkbox, FormControlLabel, TextField, Typography, Stack, Card as MuiCard } from '@mui/material';
import { styled } from '@mui/material/styles';
import {  Divider } from '@mui/material';
import { withRouter } from "./withRouter";

const GlassCard = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: { maxWidth: 460 },

  /* glassmorphism */
  background: 'rgba(255,255,255,0.75)',
  backdropFilter: 'blur(11px)',
  border: '1px solid rgba(255,255,255,0.35)',
  borderRadius: 20,
  boxShadow:
    '0 8px 32px 0 rgba(31, 38, 135, 0.15), 0 6px 20px 0 rgba(0,0,0,0.08)',

  /* dark‑mode tweak */
  ...theme.applyStyles('dark', {
    background: 'rgba(30,30,40,0.35)',
    border: '1px solid rgba(255,255,255,0.12)',
  }),
}));


axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;



const SignInContainer = styled(Stack)(({ theme }) => ({
  padding: 20,
  marginTop: '10vh',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: false,
      registrationToggle: false,
      email: '',
      username: '',
      password: '',
      registrationSuccess: false,
      errorDialogOpen: false,
      errorDialogMessage: '',
      plan: 'trial',
      confirmDialogOpen: false,
      loginError: '',
      registrationError: '',
    };
  }

  componentDidMount() {
    axios.get('/api/user-info/')
      .then((res) => {
        this.setState({ currentUser: true });
        this.props.navigate('/NZ2026');   // 👈 instead of history.push
      })
      .catch(() => {
        this.setState({ currentUser: false });
      });
  }
  
  

  handleOpenErrorDialog = (message) => {
    this.setState({ errorDialogOpen: true, errorDialogMessage: message });
  };

  handleCloseErrorDialog = () => {
    this.setState({ errorDialogOpen: false, errorDialogMessage: '' });
  };

  updateFormBtn = () => {
    this.setState((prevState) => ({ registrationToggle: !prevState.registrationToggle }));
  };
  
submitLogin = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
  
    axios
    .post('/api/user/login/', { email, password })
    .then(() => this.props.navigate('/NZ2026'))
    .catch(() =>
      this.setState({ loginError: 'Invalid email or password.' })
    );  
}
  
  
  render() {
    const {
      email,
      password,
    } = this.state;
    

    const backgroundImageStyle = {
      backgroundImage: `url('/static/images/districtstatic.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '0px',
    };

    return (
      <SignInContainer direction="column" style={backgroundImageStyle}>
        <GlassCard
          sx={{
            p: { xs: 3, sm: 5 },
            width: { xs: '91%', sm: 420, md: 480 },
            gap: 1.5,
          }}
        >
       
          <Box sx={{ textAlign: 'center', mb: 1 }}>
            <img src="/static/images/NZdashlogo.png" alt="Logo" width={220} />
          </Box>
    
          <Typography
            variant="h4"
            fontWeight={700}
            align="center"
            sx={{ letterSpacing: 0.5 }}
            
          >
            {'Sign-In'}
          </Typography>

     
      
          <Box
            component="form"
            onSubmit= {this.submitLogin}
            noValidate
            sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}
          >
          
           <TextField 
                  type="email"
                  label="Email Address"
                  fullWidth
                  value={email}
                  onChange={(e) =>
                this.setState({ email: e.target.value, loginError: '' })
                  }
                />
                <TextField
                  type="password"
                  label="Password"
                  fullWidth
                  value={password}
                  onChange={(e) =>
                this.setState({ password: e.target.value, loginError: '' })
                  }
                />
                {this.state.loginError && (
                  <Typography
                    variant="body2"
                    color="error"
                    sx={{ mt: 1, textAlign: 'center' }}
                  >
                    {this.state.loginError}
                  </Typography>
                )}
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  label="Remember me"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    py: 1.3,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                  }}
                >
                  Sign In
                </Button>

          </Box>
    
          
          <Divider sx={{ my: .5 }} />
 

        </GlassCard>
      </SignInContainer>
    );
    
  }
}

export default withRouter(SignIn);
